/**
 * CIH (Coaching Intelligence Hub) database enums for Drizzle schema.
 * These are TypeScript enums that correspond to PostgreSQL enum types.
 *
 * For runtime validation of the string values, prefer the Zod schemas in
 * `~/lib/shared/content-status` (`contentStatusSchema`, `frameworkTypeSchema`)
 * — they share the same value space and stay safe across the client/server
 * boundary.
 */

export enum ContentStatus {
  Draft = "draft",
  InReview = "in_review",
  Published = "published",
  Archived = "archived",
}

export enum FrameworkType {
  Framework = "framework",
  Methodology = "methodology",
  Standard = "standard",
  Protocol = "protocol",
}

// ─── CIH V3 — Coach Business Builder vertical ───────────────────────────────

/** Guide page type — drives template variant and filtering. */
export enum GuideType {
  StageGuide = "stage_guide",
  Tool = "tool",
  Comparison = "comparison",
}

/** Coach practice stage — drives CTA routing (to CBB tiers) and filtering. */
export enum PracticeStage {
  Starting = "starting",
  Growing = "growing",
  Scaling = "scaling",
  All = "all",
}

// The PrcPR taxonomy enums (`practiceStageBandSchema`, `prcprLinkSchema`) are
// declared in `~/lib/shared/content-status` and used directly by the Drizzle
// schema. They have no TypeScript-enum twin here on purpose: a nominal enum
// makes every parsed string need a cast on its way into a column.

/** Thought-leader IP sensitivity — governs editorial caution on playbooks. */
export enum IpSensitivity {
  High = "high",
  Medium = "medium",
  Low = "low",
}

/** Thought-leader partnership tier. */
export enum PartnerTier {
  Tier1 = "tier1",
  Tier2 = "tier2",
  Tier3 = "tier3",
}
